import { Flex, Box } from "rebass/styled-components";
import Trans from "next-translate/Trans";
import ReviewCard from "./ReviewCard";
import Pagination from "../common/Pagination";
import Heading from "../common/Heading";
import Rating from "../common/Rating";
import { Loader } from "../common/loader";
import { useIsDesktop } from "../../lib/media";

interface Props {
  loading: boolean;
  reviews: any;
  fetchMore: any;
  reviewScore: number;
  reviewsCount: number;
}

const Reviews = ({
  loading,
  reviews,
  fetchMore,
  reviewScore,
  reviewsCount
}: Props) => {
  const { totalPages, currentPage } = reviews;

  const isDesktop = useIsDesktop();

  const paginate = page => {
    fetchMore({
      variables: {
        page: page
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        return fetchMoreResult;
      }
    });
  };

  return (
    <>
      <Box
        py={3}
        sx={{
          borderBottom: "default"
        }}
      >
        <Flex alignContent="baseline" px={[2, 0]}>
          <Box width={1 / 2}>
            <Heading as="h2" fontWeight="book" fontSize={5}>
              <Trans
                values={{ count: reviewsCount }}
                i18nKey="sitterprofile:review"
              />
            </Heading>
          </Box>
          <Flex
            width={1 / 2}
            textAlign="right"
            fontSize={6}
            sx={{ flexDirection: "row-reverse" }}
          >
            <Rating score={reviewScore}></Rating>
          </Flex>
        </Flex>
      </Box>
      <Box mb={4} sx={{ position: "relative" }}>
        {loading && <Loader />}
        {reviews.results.map(review => (
          <ReviewCard key={review.id} review={review} />
        ))}
      </Box>
      <Pagination
        onPaginate={paginate}
        totalPages={totalPages}
        maxPages={isDesktop ? 9 : 5}
        currentPage={currentPage}
      />
    </>
  );
};

export default Reviews;
